module.exports = __webpack_public_path__ + "static/media/land-rover-go-drive.aeb5a14d.jpg";